import { useCreateBotChat } from "@circle-react/components/SettingsApp/CommunityInbox/hooks/useCreateBotChat";
import { textToRichText } from "@circle-react/helpers/richTextHelpers";
import type { Profile } from "@circle-react/types/CommunityBot/Profile";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { useNavigate } from "@tanstack/react-router";

export const useStartAvatarDmChat = () => {
  const navigate = useNavigate();
  const { createChat } = useCreateBotChat();

  return (avatar: Profile, question: string) => {
    void createChat({ id: avatar.id, body: textToRichText(question) })
      .then((chat: Chat) => {
        void navigate({
          to: "/messages/bot/$id",
          params: { id: String(chat.id) },
        });
      })
      .catch(e => {
        console.error(e);
      });
  };
};
